import { Box, Paper, Typography } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useIntl } from 'react-intl';
import AppPaperTitle from 'src/app/common/components/AppPaperTitle';
import AppPaperContent from 'src/app/common/components/AppPaperContent';
import { useBatchFilesSubmitPageContext } from '../../BatchFilesSubmitPage.context';
import { formatNumber } from 'src/app/modules/OpmPd/utils/commonHelper';

const ImportSummary = () => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const { bdmBatchFile } = useBatchFilesSubmitPageContext();
  const totalPolicies = bdmBatchFile?.importedPoliciesCount;
  const validPolicies = bdmBatchFile?.policies?.length || 0;
  const invalidPolicies = totalPolicies ? totalPolicies - validPolicies : 0;

  return (
    <Paper>
      <AppPaperTitle>{Translation('opm_pd.importSummary')}</AppPaperTitle>
      <AppPaperContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={4}>
          <Box display="flex" alignItems="center" gap={1}>
            <ArticleIcon sx={{ color: 'text.secondary', fontSize: 32 }} />
            <Box>
              <Typography variant="body2" color="text.secondary">
                {Translation('opm_pd.totalPolicies')}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatNumber(totalPolicies || 0)}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <CheckCircleIcon sx={{ color: 'success.main', fontSize: 32 }} />
            <Box>
              <Typography variant="body2" color="text.secondary">
                {Translation('opm_pd.validPolicies')}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatNumber(validPolicies || 0)}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <ErrorIcon sx={{ color: 'error.main', fontSize: 32 }} />
            <Box>
              <Typography variant="body2" color="text.secondary">
                {Translation('opm_pd.invalidPolicies')}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatNumber(invalidPolicies || 0)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </AppPaperContent>
    </Paper>
  );
};

export default ImportSummary;
